import '~/js/libs/jquery.countdown.min';
import moment from 'moment';

let countDownDate = sandals_app.page.countdown;
let endTime = sandals_app.page.endTime;

const $countDown = $('.js-dsc-count');
const newDate = new Date('2024-08-31');

// updated

// let startDate = ('date' in sandals_app.page.countdown) ? sandals_app.page.countdown.date : newDate;
// if (moment(startDate).isBefore(newDate)) {
//   startDate = newDate;
//   startDate = newDate;
// }

if (moment(countDownDate + ' ' + endTime).isBefore(moment(newDate))) {
  countDownDate =
    newDate.getFullYear() +
    '-' +
    (newDate.getMonth() + 1) +
    '-' +
    newDate.getDate();
  endTime = '23:59';
}

// const date = moment(startDate, 'YYYY-MM-DD').add(1, 'days');
const date = moment(countDownDate + ' ' + endTime);

$countDown.countdown(date.format('YYYY-MM-DD') + ' ' + endTime, (event) => {
  $(event.currentTarget).html(
    event.strftime(
      '' +
        '<div><span class="count-digits">%D</span> days</div>' +
        '<div><span class="count-digits">%H</span> hours</div>' +
        '<div><span class="count-digits">%M</span> min.</div>' +
        '<div><span class="count-digits">%S</span> sec.</div>'
    )
  );
});
